const images = {
    company: 'images/MP-Header-BG-company.png',
    property: 'images/MP-Header-BG-property.png',
    default: 'images/MP-Header-BG-default.png'
}
export default images;